@if (listing){
<!-- loaded icon -->
@if (!hasMore) {
<div class="flex flex-justify-center">
    <span class="_products-loaded-icon fs-11 col-3 icon-tick"></span>
</div>
}
<!-- number of viewed elements  -->
<p class="p1 col-1"
   [class.m-t-3]="!hasMore">{{ 'Viewing' | translate}}&nbsp;<span class="s1">{{visibleQty}}&nbsp;</span>{{ 'of'
    |
    translate}}&nbsp;<span class="s1">{{totalQty}}</span>
</p>
<!-- progress bar -->
<div class="m-t-7">
    <progress-bar [currentValue]="visibleQty"
                  [maxValue]="totalQty"></progress-bar>
</div>
<!-- view more button -->
<button [buttonStyle]="'button-1'"
        class="m-t-7"
        role="button"
        [disabled]="!hasMore"
        (click)="listing.increaseLimit()"
        [attr.aria-label]="'View more' | translate">{{'Load more' | translate}}</button>
}